import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  changePasswordFailure,
  changePasswordStart,
  changePasswordSuccess,
} from "../../store/features/changePassword/changePasswordSlice";
import {
  API_BASE_URL,
  defaultAxiosConfig,
  parseApiError,
  validateRequiredParams,
} from "../utils";

const ENDPOINT = "/api/v1/user/reset-password/";

const changePasswordApi = async ({ password, confirm_password, uid }) => {
  validateRequiredParams({ password, confirm_password, uid }, [
    "password",
    "confirm_password",
    "uid",
  ]);

  const response = await axios.post(
    `${API_BASE_URL}${ENDPOINT}`,
    { password, confirm_password },
    {
      params: { uid },
      ...defaultAxiosConfig,
    }
  );

  return response.data;
};

function* handleChangePasswordSaga(action) {
  try {
    const data = yield call(changePasswordApi, action.payload);
    yield put(changePasswordSuccess(data));
  } catch (error) {
    const errorMessage = parseApiError(error);
    yield put(changePasswordFailure(errorMessage));
  }
}

export default function* changePasswordSaga() {
  yield takeLatest(changePasswordStart.type, handleChangePasswordSaga);
}
